var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { attrs: { dense: "", "no-border": "" } },
    [
      _vm.schema.header
        ? _c("q-list-header", [_vm._v(_vm._s(_vm.schema.header))])
        : _vm._e(),
      _vm._l(_vm.schema.fields, function(field) {
        return _vm.role === "icor" && field.IsHidden === 0
          ? _c(
              "div",
              { key: field.name },
              [
                _c("q-item-separator", { attrs: { "inset-separator": "" } }),
                field.FieldTypeID === 144 && field.IsMemo === 1
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "description", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.FieldTypeID === 144
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "title", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.FieldTypeID === 32
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "money", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.FieldTypeID === 64
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "money", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.FieldTypeID === 96
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "event", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-datetime", {
                                      attrs: {
                                        type: "date",
                                        "cancel-label": "anuluj",
                                        "ok-label": "OK",
                                        "clear-label": "wyczyść",
                                        "month-names": [
                                          "styczeń",
                                          "luty",
                                          "marzec",
                                          "kwiecień",
                                          "maj",
                                          "czerwiec",
                                          "lipiec",
                                          "sierpień",
                                          "wrzesień",
                                          "październik",
                                          "listopad",
                                          "grudzień"
                                        ],
                                        "day-names": [
                                          "poniedziałek",
                                          "wtorek",
                                          "środa",
                                          "czwartek",
                                          "piątek",
                                          "sobota",
                                          "niedziela"
                                        ],
                                        "monday-first": "",
                                        format: "YYYY-MM-DD",
                                        format24h: "",
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.FieldTypeID === 112
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "check", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-toggle", {
                                      attrs: { "left-label": "" },
                                      on: {
                                        change: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.FieldTypeID > 255
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "list", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : field.IsHidden === 0
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "email", color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name]),
                                      label: field.label,
                                      "label-width": _vm.labelWidth
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      }),
      _vm._l(_vm.schema.fields, function(field) {
        return _vm.role !== "icor"
          ? _c(
              "div",
              { key: field.name },
              [
                field.type === "text" ||
                field.type === "password" ||
                field.type === "textarea"
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: field.icon, color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name])
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        autofocus: "",
                                        type: field.type,
                                        "float-label": field.label,
                                        rows:
                                          field.type === "textarea" ? 12 : 1,
                                        wrap: "hard",
                                        cols:
                                          field.type === "textarea" ? 80 : 40,
                                        "max-height": 120,
                                        after: _vm.getAfterButtons(field)
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "bool"
                  ? _c(
                      "q-item",
                      { attrs: { "inset-separator": "" } },
                      [
                        _c("q-item-side", {
                          attrs: { icon: field.icon, color: "primary" }
                        }),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.$v.data[field.name].$error,
                                      "error-label":
                                        "" +
                                        _vm.errorMsg(_vm.$v.data[field.name])
                                    }
                                  },
                                  [
                                    _c("q-toggle", {
                                      attrs: { label: field.label },
                                      on: {
                                        change: function($event) {
                                          _vm.$v.data[field.name].$touch
                                        }
                                      },
                                      model: {
                                        value: _vm.data[field.name],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, field.name, $$v)
                                        },
                                        expression: "data[field.name]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            field.helper !== ""
                              ? _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.helper) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("q-item-side", { attrs: { right: "" } })
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "separator"
                  ? _c("q-item-separator", { attrs: { inset: "" } })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      }),
      _c("q-item-separator", { attrs: { inset: "" } }),
      _vm.schema.buttons.length > 0
        ? _c(
            "q-item",
            [
              _c(
                "q-item-main",
                [
                  _c(
                    "q-btn-group",
                    { attrs: { rounded: "" } },
                    _vm._l(_vm.schema.buttons, function(button) {
                      return _c("q-btn", {
                        key: button.buttonid,
                        attrs: {
                          rounded: "",
                          icon: button.icon,
                          color: button.color,
                          label: button.label,
                          disabled: button.onlyvalid ? _vm.$v.$invalid : false
                        },
                        on: {
                          click: function($event) {
                            return _vm.buttonClick(button)
                          }
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }